export default "__VITE_ASSET__CJraEfos__"